export class GroupHeader {
  label: string;
  cssClass: string;

  constructor(label: string, cssClass: string) {
    this.label = label;
    this.cssClass = cssClass;
  }
}
